<template>
  <div>
    <section class="xs-banner service-banner-2 contet-to-center">
      <div class="container">
        <div class="row">
          <div class="col-lg-7 col-md-6 align-self-center">
            <div class="xs-banner-content">
              <div class="xs-banner-group">
                <h2 class="banner-title wow fadeInLeft" data-wow-duration="1s">VPS HOSTING</h2>
                <p class="wow fadeInLeft" data-wow-duration="1.5s">Share processes and data securely on a need to know
                  basis without the need for reconciliation it combines a permissione.</p></div>
            </div>
          </div>
          <div class="col-lg-5 col-md-6 align-self-center">
            <div class="inner-welcome-image-group wow fadeIn">
              <img src="../assets/images/cloud-hosting-bg.png" data-parallax='{"y": 150}'
                   alt="hosting image">
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="page" role="main">
      <div class="builder-content">
        <!-- full-width-content -->
        <div id="post-1306" class="full-width-content post-1306 page type-page status-publish hentry">
          <div data-elementor-type="wp-page" data-elementor-id="1306"
               class="elementor elementor-1306 elementor-bc-flex-widget" data-elementor-settings="[]">
            <div class="elementor-inner">
              <div class="elementor-section-wrap">
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-a4bc63a elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="a4bc63a" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-4f8bce1"
                        data-id="4f8bce1" data-element_type="column">
                        <div class="elementor-column-wrap">
                          <div class="elementor-widget-wrap">
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-2ac75af"
                        data-id="2ac75af" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-d067b5d elementor-widget elementor-widget-xs-heading"
                              data-id="d067b5d" data-element_type="widget" data-widget_type="xs-heading.default">
                              <div class="elementor-widget-container">
                                <div class="xs-heading">
                                  <h3 class="heading-sub-title">Best Hosting</h3>
                                  <h2 class="heading-title">Why <span>CHOOSE US</span></h2>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-2118fd0"
                        data-id="2118fd0" data-element_type="column">
                        <div class="elementor-column-wrap">
                          <div class="elementor-widget-wrap">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-01a0b7d elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="01a0b7d" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-ad763a3 animated-slow animated fadeInUp"
                        data-id="ad763a3" data-element_type="column"
                        data-settings="{&quot;animation&quot;:&quot;fadeInUp&quot;,&quot;animation_delay&quot;:0.7}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-a73c054 elementor-widget elementor-widget-xs-image-box"
                              data-id="a73c054" data-element_type="widget" data-widget_type="xs-image-box.default">
                              <div class="elementor-widget-container">
                                <div class="why-choose-us-block">
                                  <div class="choose-us-img">
                                    <img width="254" height="190"
                                         src="../assets/images/choose-us-1.png"
                                         class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                  </div>
                                  <h4 class="xs-title">99.9% Uptime Guarantee</h4>
                                  <p>Share processes and data secure
                                    lona need to know basis</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-46aa5ce animated-slow animated fadeInUp"
                        data-id="46aa5ce" data-element_type="column"
                        data-settings="{&quot;animation&quot;:&quot;fadeInUp&quot;,&quot;animation_delay&quot;:1.5}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-7a08d97 elementor-widget elementor-widget-xs-image-box"
                              data-id="7a08d97" data-element_type="widget" data-widget_type="xs-image-box.default">
                              <div class="elementor-widget-container">
                                <div class="why-choose-us-block">
                                  <div class="choose-us-img">
                                    <img width="254" height="190"
                                         src="../assets/images/choose-us-2.png"
                                         class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                  </div>
                                  <h4 class="xs-title">Safe and Secured</h4>
                                  <p>Our team assured your web site is always safe and secure</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-baad171 animated-slow animated fadeInUp"
                        data-id="baad171" data-element_type="column"
                        data-settings="{&quot;animation&quot;:&quot;fadeInUp&quot;,&quot;animation_delay&quot;:2}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-544c1ab elementor-widget elementor-widget-xs-image-box"
                              data-id="544c1ab" data-element_type="widget" data-widget_type="xs-image-box.default">
                              <div class="elementor-widget-container">
                                <div class="why-choose-us-block">
                                  <div class="choose-us-img">
                                    <img width="254" height="190"
                                         src="../assets/images/choose-us-3.png"
                                         class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                  </div>
                                  <h4 class="xs-title">Our Dedicated Support</h4>
                                  <p>We finally found a host that truly understood the unique</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-33ba384 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="33ba384" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-252cedc"
                        data-id="252cedc" data-element_type="column"
                        data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-636132e elementor-widget elementor-widget-xs-vps-slider"
                              data-id="636132e" data-element_type="widget" data-widget_type="xs-vps-slider.default">
                              <div class="elementor-widget-container">
                                <div class="slider-group">
                                  <div
                                    class="vps-slider ui-slider ui-slider-horizontal ui-widget ui-widget-content ui-corner-all">
                                    <div class="ui-slider-range ui-widget-header ui-corner-all ui-slider-range-min"
                                         style="width: 0%;"></div>
                                    <span class="ui-slider-handle ui-state-default ui-corner-all" tabindex="0"
                                          style="left: 0%;"></span></div><!-- .vps-slider END -->
                                  <div class="slider-range clearfix">
                                    <div id="icon-0" class="slider-tigger"><h5>Basic</h5></div>
                                    <div id="icon-1" class="slider-tigger"><h5>Starter</h5></div>
                                    <div id="icon-2" class="slider-tigger"><h5>Enterprise</h5></div>
                                    <div id="icon-3" class="slider-tigger"><h5>Business</h5></div>
                                    <div id="icon-4" class="slider-tigger"><h5>Pro</h5></div>
                                  </div><!-- .slider-range END -->
                                </div><!-- .slider-group END -->
                                <div class="slider-content-group">
                                  <div class="row">
                                    <div class="col-lg-5">
                                      <div class="slider-container">
                                        <!-- title -->
                                        <p class="title xs0">Basic</p>
                                        <input type="hidden" name="title" class="title xs0" autocomplete="off"
                                               autocorrect="off" value="Basic">

                                        <!-- price -->
                                        <h2 class="price xs1">$5.99</h2>
                                        <input type="hidden" name="price" class="price xs1" autocomplete="off"
                                               autocorrect="off" value="$5.99">

                                        <!-- description -->
                                        <p class="desc xs2">It is a paradisematic country, in which roasted parts of
                                          sentences fly into your mouth. Even the all-powerful Pointing has no control
                                          about the blind texts it is an almost unorthographic life One day however a
                                          small line of blind text by the name</p>
                                        <input type="hidden" name="desc" class="desc xs2" autocomplete="off"
                                               autocorrect="off"
                                               value="It is a paradisematic country, in which roasted parts of sentences fly into your mouth. Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name">

                                        <!-- buttons -->
                                        <a class="btn btn-primary slider-btns"
                                           href="http://whmcs.finesttheme.com/cart.php?a=add&amp;pid=3" target="_blank"><span
                                          class="icon icon-checkmark"></span> Purchase Now</a>
                                      </div><!-- .slider-container END -->
                                    </div>
                                    <div class="col-lg-7">
                                      <ul class="vps-pricing-list clearfix">
                                        <li>
                                          <h4>CPU</h4>
                                          <p class="cpu xs3">1 Core</p>
                                          <input type="hidden" name="cpu" class="cpu xs3" autocomplete="off"
                                                 autocorrect="off" value="1 Core">
                                        </li>
                                        <li>
                                          <h4>Bandwidth</h4>
                                          <p class="brandwidth xs4">100 GB</p>
                                          <input type="hidden" name="brandwidth" class="brandwidth xs4"
                                                 autocomplete="off" autocorrect="off" value="100 GB">
                                        </li>
                                        <li>
                                          <h4>Bandwidth Two</h4>
                                          <p class="brandwidth2 xs5">.5 TB</p>
                                          <input type="hidden" name="brandwidth2" class="brandwidth2 xs5"
                                                 autocomplete="off" autocorrect="off" value=".5 TB">
                                        </li>
                                      </ul><!-- .vps-pricing-list END -->
                                      <ul class="vps-pricing-list clearfix">
                                        <li>
                                          <h4>RAM</h4>
                                          <p class="ram xs6">1 GB</p>
                                          <input type="hidden" name="ram" class="ram xs6" autocomplete="off"
                                                 autocorrect="off" value="1 GB">
                                        </li>
                                        <li>
                                          <h4>Setup</h4>
                                          <p class="setup xs7">Paid</p>
                                          <input type="hidden" name="setup" class="setup xs7" autocomplete="off"
                                                 autocorrect="off" value="Paid">
                                        </li>
                                        <li>
                                          <h4>Setup Two</h4>
                                          <p class="setup2 xs8">Free</p>
                                          <input type="hidden" name="setup2" class="setup2 xs8" autocomplete="off"
                                                 autocorrect="off" value="Free">
                                        </li>
                                      </ul><!-- .vps-pricing-list END -->
                                      <ul class="vps-pricing-list clearfix">
                                        <li>
                                          <h4>Disk Space</h4>
                                          <p class="diskspace xs9">100 GB</p>
                                          <input type="hidden" name="diskspace" class="diskspace xs9" autocomplete="off"
                                                 autocorrect="off" value="100 GB">
                                        </li>
                                        <li>
                                          <h4>IP</h4>
                                          <p class="ip_one xs10">Up to 1</p>
                                          <input type="hidden" name="ip_one" class="ip_one xs10" autocomplete="off"
                                                 autocorrect="off" value="Up to 1">
                                        </li>
                                        <li>
                                          <h4>IP Two</h4>
                                          <p class="ip_two xs11">Up to 0</p>
                                          <input type="hidden" name="ip_two" class="ip_two xs11" autocomplete="off"
                                                 autocorrect="off" value="Up to 0">
                                        </li>
                                      </ul><!-- .vps-pricing-list END -->
                                    </div>
                                  </div><!-- .row END -->
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-2c0d47e elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="2c0d47e" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;gradient&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-55a91f8"
                        data-id="55a91f8" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-e654bb5 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="e654bb5" data-element_type="section">
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-15c6d6f"
                                    data-id="15c6d6f" data-element_type="column">
                                    <div class="elementor-column-wrap">
                                      <div class="elementor-widget-wrap">
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-5097c63"
                                    data-id="5097c63" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-5bdd6e3 elementor-widget elementor-widget-xs-heading"
                                          data-id="5bdd6e3" data-element_type="widget"
                                          data-widget_type="xs-heading.default">
                                          <div class="elementor-widget-container">
                                            <div class="xs-heading">
                                              <h3 class="heading-sub-title">We Offer</h3>
                                              <h2 class="heading-title">FEATURES INCLUDED</h2>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-3797dcb"
                                    data-id="3797dcb" data-element_type="column">
                                    <div class="elementor-column-wrap">
                                      <div class="elementor-widget-wrap">
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-eddf95e elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="eddf95e" data-element_type="section">
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-17485f3"
                                    data-id="17485f3" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-ca188a3 elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                                          data-id="ca188a3" data-element_type="widget"
                                          data-widget_type="image-box.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image-box-wrapper">
                                              <figure class="elementor-image-box-img"><img width="49" height="68"
                                                                                           src="../assets/images/included-feature-1.png"
                                                                                           class="attachment-full size-full"
                                                                                           alt="" loading="lazy"
                                                                                           draggable="false"></figure>
                                              <div class="elementor-image-box-content"><h3
                                                class="elementor-image-box-title">No Multi Tenancy</h3>
                                                <p class="elementor-image-box-description">Share processes and data
                                                  secure lon a need to know basis with out the need for reconciliation
                                                  it combines.</p></div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-71b2b77 elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                                          data-id="71b2b77" data-element_type="widget"
                                          data-widget_type="image-box.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image-box-wrapper">
                                              <figure class="elementor-image-box-img"><img width="52" height="67"
                                                                                           src="../assets/images/included-feature-2.png"
                                                                                           class="attachment-full size-full"
                                                                                           alt="" loading="lazy"
                                                                                           draggable="false"></figure>
                                              <div class="elementor-image-box-content"><h3
                                                class="elementor-image-box-title">LiteSpeed Web Server</h3>
                                                <p class="elementor-image-box-description">Share processes and data
                                                  secure lon a need to know basis with out the need for reconciliation
                                                  it combines.</p></div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-f7166f7 elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                                          data-id="f7166f7" data-element_type="widget"
                                          data-widget_type="image-box.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image-box-wrapper">
                                              <figure class="elementor-image-box-img"><img width="50" height="45"
                                                                                           src="../assets/images/included-feature-3.png"
                                                                                           class="attachment-full size-full"
                                                                                           alt="" loading="lazy"
                                                                                           draggable="false"></figure>
                                              <div class="elementor-image-box-content"><h3
                                                class="elementor-image-box-title"> cPanel Hosting Control</h3>
                                                <p class="elementor-image-box-description">Share processes and data
                                                  secure lon a need to know basis with out the need for reconciliation
                                                  it combines.</p></div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-3246f46"
                                    data-id="3246f46" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-ac0fc2d elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                                          data-id="ac0fc2d" data-element_type="widget"
                                          data-widget_type="image-box.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image-box-wrapper">
                                              <figure class="elementor-image-box-img"><img width="49" height="41"
                                                                                           src="../assets/images/included-feature-4.png"
                                                                                           class="attachment-full size-full"
                                                                                           alt="" loading="lazy"
                                                                                           draggable="false"></figure>
                                              <div class="elementor-image-box-content"><h3
                                                class="elementor-image-box-title">PHP Selector</h3>
                                                <p class="elementor-image-box-description">Share processes and data
                                                  secure lon a need to know basis with out the need for reconciliation
                                                  it combines.</p></div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-b257f84 elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                                          data-id="b257f84" data-element_type="widget"
                                          data-widget_type="image-box.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image-box-wrapper">
                                              <figure class="elementor-image-box-img"><img width="52" height="53"
                                                                                           src="../assets/images/included-feature-5.png"
                                                                                           class="attachment-full size-full"
                                                                                           alt="" loading="lazy"
                                                                                           draggable="false"></figure>
                                              <div class="elementor-image-box-content"><h3
                                                class="elementor-image-box-title"> LiteSpeed Web Server</h3>
                                                <p class="elementor-image-box-description">Share processes and data
                                                  secure lon a need to know basis with out the need for reconciliation
                                                  it combines.</p></div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-7c32a8e elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                                          data-id="7c32a8e" data-element_type="widget"
                                          data-widget_type="image-box.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image-box-wrapper">
                                              <figure class="elementor-image-box-img"><img width="47" height="55"
                                                                                           src="../assets/images/included-feature-6.png"
                                                                                           class="attachment-full size-full"
                                                                                           alt="" loading="lazy"
                                                                                           draggable="false"></figure>
                                              <div class="elementor-image-box-content"><h3
                                                class="elementor-image-box-title"> Patchman Kiler</h3>
                                                <p class="elementor-image-box-description">Share processes and data
                                                  secure lon a need to know basis with out the need for reconciliation
                                                  it combines.</p></div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-674595a elementor-section-height-min-height elementor-section-boxed elementor-section-height-default elementor-section-items-middle"
                  data-id="674595a" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-608c3b7"
                        data-id="608c3b7" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-e5610ba elementor-widget elementor-widget-xs-testimonial"
                              data-id="e5610ba" data-element_type="widget" data-widget_type="xs-testimonial.default">
                              <div class="elementor-widget-container">
                                <div class="xs-testimonial-slider owl-carousel owl-loaded owl-drag">

                                  <!-- Testimonial Content End -->

                                  <!-- Testimonial Content End -->

                                  <!-- Testimonial Content End -->

                                  <!-- Testimonial Content End -->

                                  <div class="owl-stage-outer">
                                    <div class="owl-stage"
                                         style="transition: all 0s ease 0s; width: 3834px; transform: translate3d(-766px, 0px, 0px);">
                                      <div class="owl-item cloned" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-2-55x55.png"
                                                  alt="avatar-2" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Richard I Jones</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-1-55x55.png"
                                                  alt="avatar-1" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Cecilia H King</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned active" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-4-55x55.jpg"
                                                  alt="avatar-4" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Joe D Walczak</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item active center" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-3-55x55.png"
                                                  alt="avatar-3" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Joe D Walczak</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-2-55x55.png"
                                                  alt="avatar-2" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Richard I Jones</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-1-55x55.png"
                                                  alt="avatar-1" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Cecilia H King</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-4-55x55.jpg"
                                                  alt="avatar-4" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Joe D Walczak</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-3-55x55.png"
                                                  alt="avatar-3" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Joe D Walczak</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-2-55x55.png"
                                                  alt="avatar-2" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Richard I Jones</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-1-55x55.png"
                                                  alt="avatar-1" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Cecilia H King</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="owl-nav disabled">
                                    <div class="owl-prev"></div>
                                    <div class="owl-next"></div>
                                  </div>
                                  <div class="owl-dots disabled"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-17bae3d elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="17bae3d" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-4475cd4"
                        data-id="4475cd4" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-ff89f15 elementor-widget elementor-widget-xs-partner"
                              data-id="ff89f15" data-element_type="widget" data-widget_type="xs-partner.default">
                              <div class="elementor-widget-container">
                                <div class="xs-client-slider owl-carousel owl-loaded owl-drag">


                                  <div class="owl-stage-outer">
                                    <div class="owl-stage"
                                         style="transform: translate3d(-1120px, 0px, 0px); transition: all 0s ease 0s; width: 3360px;">
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-1.png"
                                            alt="client-1" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-2.png"
                                            alt="client-2" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-3.png"
                                            alt="client-3" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-4.png"
                                            alt="client-4" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-5.png"
                                            alt="client-5" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-1.png"
                                            alt="client-1" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-2.png"
                                            alt="client-2" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-3.png"
                                            alt="client-3" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-4.png"
                                            alt="client-4" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-5.png"
                                            alt="client-5" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-1.png"
                                            alt="client-1" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-2.png"
                                            alt="client-2" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-3.png"
                                            alt="client-3" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-4.png"
                                            alt="client-4" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-5.png"
                                            alt="client-5" draggable="false"></a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="owl-nav disabled">
                                    <div class="owl-prev"></div>
                                    <div class="owl-next"></div>
                                  </div>
                                  <div class="owl-dots disabled"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-inner-section elementor-element elementor-element-b414681 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="b414681" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-2efebe6"
                        data-id="2efebe6" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-9038df2 elementor-widget elementor-widget-xs-call-to-action-box"
                              data-id="9038df2" data-element_type="widget"
                              data-widget_type="xs-call-to-action-box.default">
                              <div class="elementor-widget-container">
                                <div class="xs-feature-group">
                                  <div class="media">
                                    <div class="feature-img d-flex">
                                      <img width="122" height="138"
                                           src="../assets/images/sheild-2.png"
                                           class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                    </div>
                                    <div class="media-body feature-content">
                                      <h4 class="xs-title">Days money back guarantee</h4>
                                      <p>Share processes an data secure lona need to know basis without the need.</p>
                                      <div class="xs-btn-wraper">
                                        <a href="#" class="btn btn-secondary">Know More</a>
                                      </div>
                                    </div>
                                  </div>
                                  <span class="icon icon-dollar watermark-icon"></span>
                                </div><!-- .xs-feature-group END -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-cd3b1c5"
                        data-id="cd3b1c5" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-f50805e elementor-widget elementor-widget-xs-call-to-action-box"
                              data-id="f50805e" data-element_type="widget"
                              data-widget_type="xs-call-to-action-box.default">
                              <div class="elementor-widget-container">
                                <div class="xs-feature-group">
                                  <div class="media">
                                    <div class="feature-img d-flex">
                                      <img width="129" height="138"
                                           src="../assets/images/cloud-lock-2.png"
                                           class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                    </div>
                                    <div class="media-body feature-content">
                                      <h4 class="xs-title">Build and protect your brand</h4>
                                      <p>Share processes an data secure lona need to know basis without the need.</p>
                                      <div class="xs-btn-wraper">
                                        <a href="#" class="btn btn-secondary">Know More</a>
                                      </div>
                                    </div>
                                  </div>
                                  <span class="icon icon-dollar watermark-icon"></span>
                                </div><!-- .xs-feature-group END -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-6e51c52 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="6e51c52" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-5dd4818"
                        data-id="5dd4818" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-1f0bee2 elementor-widget elementor-widget-spacer"
                              data-id="1f0bee2" data-element_type="widget" data-widget_type="spacer.default">
                              <div class="elementor-widget-container">
                                <div class="elementor-spacer">
                                  <div class="elementor-spacer-inner"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div> <!-- end full-width-content -->
      </div> <!-- end main-content -->

    </div>
  </div>
</template>

<script>
export default {
  name: 'VpsHosting'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/VpsHosting.vue